import { Container, Heading, Stack } from '@chakra-ui/react';
import { FC } from 'react';
import { RelatedRoomCard } from '../RelatedRoomCard';
import styles from './RelatedRooms.module.css';
import { RelatedRoomsProps } from './RelatedRooms.props';

const RelatedRooms: FC<RelatedRoomsProps> = ({ relatedRooms }) => (
  <Container maxW="8xl" my="8rem">
    <Heading fontWeight="normal" mb="1.5rem" color="primary">
      Other rooms
    </Heading>
    <Stack direction={{ base: 'column', md: 'row' }} spacing={{ base: '3rem', md: '2rem' }} align="center">
      {relatedRooms.map((room, i) => (
        <RelatedRoomCard relatedRoom={room} key={room._id} index={i} />
      ))}
    </Stack>
  </Container>
);

export { RelatedRooms };
